import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

import Login from '../components/login/login.vue'
import Register from '../components/login/register'
import Account from '../components/account/index.vue'
import Domain from '../components/domain/DomainIndex.vue'
import DomainCreate from '../components/domain/DomainCreate'
import DomainEdit from '../components/domain/DomainEdit'
import ReportIndex from '../components/report/ReportIndex'
import LeadIndex from "../components/lead/LeadIndex";
import VisitReport from "../components/visit/VisitReport";

Vue.use(VueRouter);

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next();
        return
    }
    next('/')
};

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next();
        return
    }
    next('/login')
};

const firstRoute = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next('/report');
    } else {
        next('/login');
    }
};


const routes = [
    {path: '/', beforeEnter: firstRoute},

    {path: '/login', component: Login, beforeEnter: ifNotAuthenticated},
    {path: '/register', component: Register, beforeEnter: ifNotAuthenticated},
    {path: '/account', component: Account, beforeEnter: ifAuthenticated},

    {path: '/domain', component: Domain, name: 'domainIndex', beforeEnter: ifAuthenticated},
    {path: '/domain/create', component: DomainCreate, name: 'domainCreate', beforeEnter: ifAuthenticated},
    {path: '/domain/edit/:id', component: DomainEdit, name: 'domainEdit', beforeEnter: ifAuthenticated},

    {path: '/report', component: ReportIndex, beforeEnter: ifAuthenticated},
    {path: '/visit/report/:id', component: VisitReport, beforeEnter: ifAuthenticated},

    {
        path: '/lead',
        name: 'lead',
        component: LeadIndex,
        beforeEnter: ifAuthenticated
    },
];

export default new VueRouter({
    mode: 'history',
    routes // сокращённая запись для `routes: routes`
});
